import { LemonIcon } from "@sanity/icons"
import { defineArrayMember, defineField, defineType } from "@sanity-typed/types"
import { SanityValues } from "sanity.config"
import Preview from "schemas/objects/helpers/Preview"

const type = defineType({
  type: "object",
  name: "textBlock",
  title: "Text Block",
  icon: LemonIcon,

  fields: [
    defineField({
      name: "content",
      title: "Content",
      type: "array",
      of: [
        defineArrayMember({
          type: "block",

          styles: [
            { title: "Normal", value: "normal" },
            { title: "Small", value: "small" },
            { title: "H1", value: "h1" },
            { title: "H2", value: "h2" },
            { title: "H3", value: "h3" },
            { title: "H4", value: "h4" },
            { title: "H5", value: "h5" },
            { title: "H6", value: "h6" },
            { title: "Quote", value: "blockquote" },
          ],

          marks: {
            annotations: [
              {
                name: "fontSize",
                type: "object",
                title: "Font Size",
                fields: [
                  {
                    name: "size",
                    type: "string",
                    title: "Font Size",
                    description:
                      "Enter a valid CSS font size (e.g., 16px, 1.2rem, 150%)",
                    validation: Rule =>
                      Rule.regex(/^\d+(px|em|rem|pt|%)$/, {
                        name: "font-size",
                        invert: false,
                        message:
                          "Enter a valid CSS font size (e.g., 16px, 1.2rem, 150%)",
                      }),
                  },
                ],
              },
            ],
          },
        }),
      ],
    }),
    defineField({
      name: "align",
      title: "Align",
      type: "string",
      initialValue: "left",
      options: {
        list: [
          { title: "Left", value: "left" },
          { title: "Center", value: "center" },
          { title: "Right", value: "right" },
        ],
      },
    }),
  ],

  components: {
    preview: () => <Preview title={type.title} icon={type.icon} />,
  },
})

export const textBlockType = type
export type TextBlock = SanityValues["textBlock"]
export const textBlockSchema = type
